<template>
    <div
      :class="[
         noGrid ? '' : (grid ? 'col-md-' + grid : 'col-md-12'),
         noGrid ? '' : 'col-sm-12'
      ]"
    >
        <div class="form-group mb-2">
            <label class="d-block font-weight-bold">
                {{ label }}
                <span v-if="required" class="text-danger">*</span>
                <span v-if="!item && label" class="small text-warning" style="font-size: 10px" v-b-tooltip.hover
                    title="Campo vazio!"><i class="fas fa-exclamation"></i></span>

                <b-link v-if="alerta" href="#" @click.prevent="void 0" class="mb-2" v-b-popover.hover.top="alerta">
                    <i class="fa fa-exclamation-triangle text-warning"></i>
                </b-link>
                <b-link v-if="ajuda" href="#" @click.prevent="void 0" class="mb-2" variant="info">
                    <!-- v-b-popover.hover.top="ajuda" -->
                    <i :id="label" class="fas fa-info-circle"></i>
                    <b-popover :target="label" triggers="hover focus" variant="info">
                        <span v-html="ajuda"></span>
                    </b-popover>

                </b-link>
            </label>
            <v-select
              ref="select"
              v-if="array"
              :options="array"
              :multiple="multiple"
              :required="required ? 'required' : false"
              :disabled="disabled || false"
              :label="labelOption || 'value'"
              :reduce="(it) => it[valueOption] || it.id"
              v-model="item"
              :filter="filter || defaultFilterFunction"
              v-on:input="
                $emit('input', item == 0 ? null : item),
                $emit('change', item)
              "
              :loading="loading"
              @option:selected="$emit('selected', item)"
              @option:deselecting="$emit('deselecting', item)"
              @search="onSearch"
              :placeholder="placeholder ? placeholder : 'Selecione'"
            >
              <template #search="{ attributes, events }">
                  <input
                    class="vs__search"
                    :required="required && !item"
                    v-bind="attributes"
                    v-on="events"
                    @input="onSearch(attributes.value)"
                  />
              </template>
                <!-- <template slot="no-options"> -->
              <template slot="no-options">
                  <em style="opacity: 0.5">{{
                      searchtext
                      ? searchtext
                      : "Nenhum resultado encontrado."
                  }}
                  </em>
                  <!-- <span v-else> Pesquise {{ label }}..</span> -->
              </template>
              <template slot="option" slot-scope="option">
                  <div v-if="customOption">
                    <slot name="option" v-bind="option" />
                  </div>
                  <div
                    v-else
                    class="d-center"
                    v-html="option[labelOption] || option.value"
                  >
                  </div>
              </template>
              <template slot="selected-option" slot-scope="option">
                  <div
                    class="selected d-center"
                    v-html="option[labelOption] || option.value"
                  >
                  </div>
              </template>
              <template #spinner="{ loading }">
                  <div
                    v-if="loading"
                    style="border-left-color: rgba(88, 151, 251, 0.71)"
                    class="vs__spinner"
                  >
                  </div>
              </template>
            </v-select>
        </div>
    </div>
</template>
<script>
export default {
    props: [
      "value",
      "itens",
      "label",
      "grid",
      "noGrid",
      "required",
      "disabled",
      "placeholder",
      "searchtext",
      "mt",
      "urlSearch",
      "multiple",
      "loading",
      "ajuda",
      "alerta",
      "labelOption",
      "valueOption",
      "filter",
      "customOption"
    ],
    data() {
        return {
          item: { id: null, value: null },
          array: [],
          search: "",
        };
    },
    beforeMount() {
      this.item = this.value;

      if (Array.isArray(this.itens)) {
          this.array = this.itens;
      }
    },
    watch: {
      value(n, o) {
          this.item = n;
      },
      itens(n, o) {
          this.array = n;
      },
    },
    methods: {
      defaultFilterFunction(options, search) {
        return options.filter(option => {
          let label = this.getOptionLabel(option);
          if (typeof label === "number") {
            label = label.toString();
          }
          return this.filterBy(option, label, search);
        });
      },

      getOptionLabel(option) {
        if (typeof option === 'object') {
          return option[this.labelOption || 'value']
        }
        return option
      },

      filterBy(option, label, search) {
        return (
          (label || '')
            .toLocaleLowerCase()
            .indexOf(search.toLocaleLowerCase()) > -1
        )
      },

      onSearch: function onSearch(value) {
          clearTimeout(onSearch.timeout);
          onSearch.timeout = setTimeout(() => {
              this.$emit("search", value);
              this.search = value;
          }, 10);
      },

      closeOptions() {
          this.$refs.select.open = false;
      },

      openOptions(value) {
          if (this.$refs.select !== undefined) {
              this.$refs.select.open = value;
          }

          if (this.search != "") {
              this.search = this.search + " ";
              this.$refs.select.select(this.search);
              setTimeout(() => {
                  this.$refs.select.open = value;
              }, 1000);
          }
      },

      getValueSelected() {
          return this.$refs.select.selectedValue[0];
      },
    },
};
</script>

<style lang="css">
.vs__dropdown-menu {
    display: block;
    box-sizing: border-box;
    position: absolute;
    top: calc(100% - 1px);
    left: 0;
    z-index: 99 !important;
    padding: 5px 0;
    margin: 0;
    width: 100% !important;
    max-height: 350px;
    min-width: 160px;
    overflow-y: auto;
    box-shadow: 0px 3px 6px 0px rgb(0 0 0 / 15%);
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-top-style: none;
    border-radius: 0 0 4px 4px;
    text-align: left;
    list-style: none;
    background: #fff;
}
</style>
